﻿/*
##  Object styles (_objects)

### Images
*/
img {
	display: inline-block;
	height: auto;
	max-width: 100%;

	.oldie & { max-width: none; }

	&.right {
		float: right;
		margin: 0 0 16px 16px;
	}
	&.left {
		float: left;
		margin: 0 16px 16px 0;
	}

	&[style*="left"] {
		margin: 0 16px 16px 0;
	}
	&[style*="right"] {
		margin: 0 0 16px 16px;
	}
}
.contain-image {
	position: relative;

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		max-height: 100%;
		width: auto;
		height: auto;
		transform: translateX(-50%) translateY(-50%);
	}
}


// ----- Animations ----- //
%linkhover {
	position: relative;
	transform: perspective(1px);

	&:before {
		background-color: #CCC;
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1;
		transition: transform 0.3s;
		transform: scaleX(0);
		transform-origin: 0 50%;
	}

	&:hover,
	&:focus {
		&:before {
			transform: scaleX(1);
		}
	}
}


// ----- Figures/Captions ----- //

figure {
	margin: 0;

	figcaption {
		color: $colour-highlight;
		font-size: rem(14);
		font-style: normal;
		font-weight: 900;
		padding: 6px;
		text-align: left;
		width: 100%;
	}

	.fig-img {
		margin: 0 auto;
	}
}

.fig-left {
	@include min(768px) {
		float: left;
		margin-bottom: 1em;
		margin-right: 1em;
	}
}
.fig-right {
	@include min(768px) {
		float: right;
		margin-bottom: 1em;
		margin-left: 1em;
	}
}


// ----- Buttons ----- //

.button {
	color: white;
	background-color: $colour-primary-500;
    border: 3px solid $colour-primary-500;
    border-radius: 0.75rem;
    display: inline-flex;
    align-items: center;
    font-family: $font-header-bold;
    font-size: 20px;
    letter-spacing: 0.5px;
    line-height: 1.2;
	transition: all 0.3s linear;
	text-decoration: none;
	text-transform: capitalize;
	padding: 9px 18px 5px;
	margin: 0;
	cursor: pointer;

	&.secondary {
		color: $colour-primary-500;
		background-color: transparent;

		&:hover,
		&:focus {
			color: $colour-primary-500;
			background-color: transparent;
		}
	}

	&.tertiary {
		background-color: #ffbf02;
	}

	&:hover,
	&:focus {
		background-color: $colour-primary-700;
		border-color: $colour-primary-700;
		color: white;
	}

	&:focus-visible {
		outline-offset: 3px;
		outline: 3px solid $colour-primary-700;
	}

	+ .button {
		margin-left: 8px;

		@include min(1360px) {
			margin-left: 16px;
		}
	}

	button.button {
		line-height: 1.4;
	}
}

.button__white {
	background-color: transparent;
	color: white;
	border-color: white;

	&:hover,
	&:focus {
		background-color: transparent;
		color: white;
	}
}

.button-round {
    border-radius: 72px;
    font-size: rem(16);
    letter-spacing: -0.02em;
    padding: 0.75em 1.2em 0.65em;
}

.button__secondary-green {
    background-color: $secondary-green;
    transition: all 0.15s linear;

	&:before {
        content: none;
	}

    &:focus {
        box-shadow: none;
		outline: none;
    }

	&:hover,
	&:focus {
		background: $colour-base-contr;
        color: $secondary-green;
        border: 1px solid $secondary-green;
	}
}

.button__primary-purple {
	background-color: #5F2478;
    transition: all 0.15s linear;

    &:before {
        content: none;
    }

    &:focus {
        box-shadow: none;
        outline: none;
    }

	&:hover,
	&:focus {
		background: $colour-base-contr;
        color: #5F2478;
        border: 1px solid #5F2478;
	}
}

// ----- Links ----- //

.link {
	background-color: transparent;
	border: none;
	color: $colour-alt;
	cursor: pointer;
	display: inline-block;
	font-size: rem(20);
	font-weight: 700;
	padding: 0;
	padding-right: 1.4em;
	position: relative;
	text-decoration: none;
	text-transform: uppercase;
	transition: color 0.3s;

	&:after {
		background-image: url(/site/images/icon/alt/chevron-right.svg);
		background-size: 11px 18px;
		// content: '';
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 11px;
		height: 18px;
		vertical-align: sub;
	}

	&:hover {
		color: darken($colour-alt, 10%);

		svg {
			use {
				fill: darken($colour-alt, 10%);
			}
		}
	}

	svg {
		position: absolute;
		top: 50%;
		right: 0;
		transform: translateY(-50%);

		use {
			fill: $colour-alt;
			transition: fill 0.3s;
		}
	}
}

.link__white {
	color: #FFF;

	&:after {
		background-image: url(/site/images/icon/white/chevron-right.svg);
	}

	&:hover {
		color: #FFF;
	}

	svg {
		use {
			fill: #FFF;
		}
	}
}

.link__green {
    display: inline-block;
    font-size: rem(16);
    line-height: 1.5;
    color: $secondary-green;
    padding: 0;
    position: relative;
    transition: color 0.3s;

    &.back-arrow {
        padding-left: 24px;

        &::after {
            content: '';
            position: absolute;
            top: calc(50% - 8px);
            left: 0;
            width: 8px;
            height: 12px;
            background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDggMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcgMUwyIDZsNSA1IiBzdHJva2U9IiM0Njk2MzgiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==');
        }
    }

    @include min(768px) {
        font-size: rem(18);
    }
}

.link__base {
	color: $colour-base;

	&:after {
		background-image: url(/site/images/icon/base/chevron-right.svg);
	}

	&:hover {
		color: $colour-base;
	}

	svg {
		use {
			fill: $colour-base;
		}
	}
}

.link__refresh {
	background-image: url(/site/images/icon/alt/refresh.svg);
	background-position: left center;
	background-size: 30px 33px;
	padding: 2px 1.4em 3px 45px;
}

.lnk-focus {
	position: relative;

	&:focus {
		outline: none;

		&:before {
			border-color: transparent #000;
			border-style: solid;
			border-width: 4px 0 4px 4px;
			content: '';
			position: absolute;
			left: -6px;
			top: 50%;
			margin-top: -4px;
		}
	}
}

// ----- Video ----- //

.video-embed-frame {
	padding-bottom: 56.25%;
	position: relative;
	width: 100%;

	iframe {
		height: 100%;
		width: 100%;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}
}


// ----- Overlays ----- //

.overlay {
	background: url(/site/images/black-50.png);
	background: rgba(0, 0, 0, 0.5);
	height: 100%;
	left: 0;
	//opacity: 0;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 100;
	transition: opacity .3s linear;
}
.overlay-box {
	background: #FFF;
	left: 50%;
	opacity: 0;
	overflow: auto;
	padding: 10px;
	position: absolute;
	top: 50%;
	width: 90%;
	max-width: 500px;
	transform: translateX(-50%) translateY(-50%);
	z-index: 101;
	max-height: 90vh;
}
.overlay__show {
	opacity: 1;
}
.overlay__hide {
	display: none;
	width: 0;
}
.overlay_close {
	background-color: transparent;
	border: none;
	cursor: pointer;
	font-size: rem(30);
	font-weight: 700;
	position: absolute;
	padding: 0;
	right: 0.2em;
	top: 0;
}
#overlay-team {
	max-width: 100%;
	min-width: 300px;
	padding: 0;

	@include min(1600px)  {
		max-width: 50%;
	}

	.cb-story {
		padding-left: 1px;
	}
}
#overlay-new {
	max-width: 900px;

	.overlay-new_inner {
		padding-bottom: 16px;
	}
}


// ----- Overlays ----- //

.cookie {
	height: 0;
	line-height: 30px;
	overflow: hidden;
	position: relative;
	background: $colour-base;
	transition: height .3s linear;

	&,
	a {
		color: #FFF;
	}

	a {
		font-weight: 700;
	}

	.inner {
		text-align: center;
		border-bottom: 1px solid $colour-base;
	}

	.lnk-accept-cookies {
		cursor: pointer;
		margin-left: 10px;
	}

	&.show {
		height: 32px;
	}
	&.hide {
		display: none !important;
		visibility: hidden;
	}
}


// ----- Inputs ----- //
textarea,
[type="text"],
[type="password"],
[type="datetime"],
[type="datetime-local"],
[type="date"],
[type="month"],
[type="time"],
[type="week"],
[type="number"],
[type="email"],
[type="url"],
[type="search"],
[type="tel"],
[type="color"] {
	border: 1px solid $colour-input-border;
	border-radius: $border-radius;
	font-size: 1em;
	padding: 5px;
	width: 100%;
	transition: border-color 0.5s, box-shadow 0.5s;

	&:focus,
	&:hover {
		border-color: darken($colour-input-border, 20%);
	}

	&:focus {
		box-shadow: 0 0 5px $colour-highlight;
	}
}

[type=file] {
	border: 1px solid $colour-input-border;
	width: 100%;
}

select {
	width: 100%;
}

.checkbox,
.radiobutton {
	label {
		vertical-align: middle;
	}
	input { vertical-align:middle; }
}

.input-replacement {
	font-weight: 700;
	line-height: 22px;
	overflow: hidden;
	position: relative;
	text-transform: uppercase;

	input {
		position: absolute;
		left: -999px;
	}
	[type=checkbox] {
		+ span {
			display: inline-block;

			&:before {
				background-color: #FFF;
				content: '';
				display: inline-block;
				margin-right: 12px;
				margin-top: -4px;
				vertical-align: middle;
				width: 22px;
				height: 22px;
			}
		}

		&:checked {
			+ span {
				&:before {
					background-image: url(/site/images/icon/alt/check.svg);
					background-position: center center;
					background-size: 18px auto;
				}
			}
		}
	}
	[type=radio] {
		+ span {
			display: inline-block;

			&:before {
				background-color: #FFF;
				border: 1px solid $colour-alt;
				border-radius: 50%;
				content: '';
				display: inline-block;
				margin-right: 12px;
				// margin-top: -4px;
				vertical-align: middle;
				width: 22px;
				height: 22px;
				transition: all 0.3s;
			}
		}

		&:checked {
			+ span {
				&:before {
					background-color: $colour-alt;
					box-shadow: inset 0 0 0 4px #FFF;
					// background-image: url(/site/images/icon/alt/check.svg);
					// background-position: center center;
					// background-size: 18px auto;
				}
			}
		}
	}

	+ .input-replacement {
		margin-left: 22px;
	}
}

@include placeholder {
	color: #666;
	opacity: .25;
}

// ----- Nice Select ----- //
.niceselect-wrapper {
	background-color: #FFF;
	border: 1px solid $colour-input-border;
	border-radius: $border-radius;
	display: block;
	line-height: lh(28);
	overflow: hidden;
	padding: 0 35px 0 10px;
	position: relative;
	transition: border-color 0.5s, box-shadow 0.5s;
	z-index: 1;

	&.focus,
	&:hover { border-color: darken($colour-input-border, 20%); } /* This is applied when the user tabs to focus or hovers on a nice select element */

	&.focus {
		box-shadow: 0 0 5px $colour-highlight;
	}

	&:after {
		background-image: url(/site/images/icon/alt/chevron-down.svg);
		background-size: 18px 11px;
		border: none;
		content: '';
		display: block;
		height: 0;
		position: absolute;
		right: 10px;
		text-indent: -99999em;
		top: 50%;
		width: 18px;
		height: 11px;
		transform: translateY(-50%);
		z-index: 5;
	} /* Creates the arrow and positions it to the right */

	.niceselect-text { /* Make sure the line-height matches the height of .niceSelect including padding */
		color: $colour-alt;
		display: block;
		padding: 1px 0;
		text-align: left;

		&:after {
			content: '\00a0';
		}
	}

	select {
		border: 1px solid #eee;
		bottom: 0;
		display: block;
		height: 100%;
		left: 0;
		opacity: 0;
		position: absolute;
		right: 0;
		top: 0;
		width: 100%;
		z-index: 10;
	} /* The height must match the overall height of .niceSelect including padding */

	&.niceselect-default {
		.niceselect-text {
			color: #999;
			opacity: .25;
		}
	}
}

.select-search-box {
    overflow: visible;
    z-index: auto;
    padding-right: 0;

    .select-search-box-search {
        appearance: none;
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        padding: 0.3rem rem(30) 0 0;
        font-size: rem(16);
        line-height: 1;
        cursor: pointer;

        &:focus {
            box-shadow: none;
        }
    }
}

.select-search-box-select {
    display: none;
    position: absolute;
    top: rem(46);
    left: -2px;
    right: -2px;
    background: #FFFFFF;
    overflow: auto;
    box-shadow: 0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07);
    z-index: 100;
    visibility: hidden;
    opacity: 0;

    .select-search-box-options {
        list-style: none;
        padding-left: 0;

        & > li {
            font-size: rem(16);
            font-weight: 400;
            line-height: 1.6;
            padding: rem(8) 0 rem(4) rem(15);
            color: #53565A;

            &.hover, &:hover {
                color: #53565A;
                background: rgba(#26ACB5, 0.05);
            }

            &.selected {
                color: #FFFFFF;
                background: rgba(#26ACB5, 0.875);
            }
        }
    }

    &.display {
        display: block;
        visibility: visible;
        opacity: 1;
    }
}

.searchbox-popup {
    .modal-close-btn {
        display: none;
    }

    .select-search-box-search:disabled {
        background: transparent;
        color: #666;
    }

    @include min(768px) {
        .form_split_3 &.form_item {
            max-width: 33.3%;
        }
    }

    @include max(540px) {
        .modal-close-btn {
            appearance: none;
            border: none;
            background-color: transparent;
            flex-direction: row;
            align-items: center;
            position: absolute;
            top: rem(20);
            right: rem(15);
            z-index: 222;
            color: #434343;
            font-size: rem(15);
            outline: none;

            .close-icon {
                position: relative;
                height: rem(16);
                width: rem(16);
                z-index: 210;
                display: block;
                margin-left: rem(6);
                transform: rotate(0);
                transition: transform 0.2s ease-in-out;
                flex-shrink: 0;

                &:hover{
                    transform: rotate(45deg);
                }

                &::before, &::after {
                    content: '';
                    height: rem(14);
                    width: 2px;
                    background-color: #434343;
                    position: absolute;
                    top: 0;
                    transform-origin: center;
                }

                &::before {
                    transform: rotate(45deg);
                }

                &::after {
                    transform: rotate(-45deg);
                }
            }
        }

        &.openSelector {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #FFFFFF;
            margin: 0 !important;
            padding: rem(50) rem(15);
            display: block;
            z-index: 120;

            .modal-close-btn {
                display: flex;
            }
        }
    }
}

// ----- Radio / Checkbox ----- //
%rcbase {
	input {
		position: absolute;
		left: -9999px;

		+ *:before {
				border: 1px solid $colour-input-border;
				box-shadow: inset 0 0 0 2px #FFF;
				height: 14px;
				width: 14px;
				transition: border-color 0.5s, background-color 0.5s, box-shadow 0.5s;
				content: '';
				display: inline-block;
				margin-right: 0.5em;
				vertical-align: middle;
		}

		&:checked,
		&:focus,
		&:active,
		&:hover {
			+ *:before {
				border-color: darken($colour-input-border, 20%);
			}
		}

		&:focus {
			+ *:before {
				box-shadow: inset 0 0 0 2px #FFF, 0 0 5px $colour-highlight;
			}
		}

		&:checked {
			+ *:before {
				background-color: $colour-highlight;
			}
		}

		&:active {
			+ *:before {
				background-color: lighten($colour-highlight, 10%);
			}
		}
	}
}
%radio {
	@extend %rcbase;

	input {
		+ * {
			&:before {
				border-radius: 50%;
			}
		}
	}

}

%checkbox {
	@extend %rcbase;

	input {
		+ * {
			&:before {
				border-radius: $border-radius;
			}
		}
	}
}


// ----- Tags ----- //
.tags {
	.tag {
		background-color: $colour-alt;
		color: #FFF;
		display: inline-block;
		font-size: rem(10);
		padding: 2px 4px;
		text-decoration: none;
		text-transform: uppercase;

		&:focus,
		&:hover {
			background-color: darken($colour-alt, 10%);
		}
	}
}


// ----- Forms ----- //
.form {
	// Formz //
	fieldset {
		+ * {
			margin-top: 10px;
		}
	}

	h2.section-title {
		font-size: 1.75rem;
		margin-top: 2.25rem;

		& + .form_item, & + p {
			margin-top: 0;
		}
	}

	label, .error-label {
		color: $colour-highlight;
		display: block;
		font-size: rem(18);
		font-weight: 700;
		text-transform: uppercase;

		+ * {
			margin-top: 8px;
		}

		&.error {
			color: #F00;
			display: block;
			font-size: rem(12);
			font-weight: 400;
			margin-top: 5px;
			text-transform: none;
		}

		&.radio {
			display: inline-block;
			font-weight: 500;
			margin-right: 1em;
		}
	}

	input,
	textarea,
	.niceselect-wrapper {
		border-color: $colour-highlight;
		line-height: 18px;
        padding: 10px;
        transition : border 250ms ease-out;

        &.niceselect-disabled {
            border-color: #cccccc;

            &:after {
                background-image: url(/site/images/icon/grey/chevron-down.svg);
            }
        }
	}

	[type=file] {
		padding: 5px;
	}

	[id$=_wrap] {
		+ * {
			margin-top: 10px;
		}

		&.radio {
			.boolDiv {
				@extend %radio;
			}
		}

		&.checkbox {
			.boolDiv {
				@extend %checkbox;
			}
		}
	}

	.niceselect-wrapper {
		&:after {
			background-image: url(/site/images/icon/highlight/chevron-down.svg);
		}

		.niceselect-text {
			color: $colour-base;
		}
	}

	.form_input__user {
		background-image: url(/site/images/icon/highlight/input-user.svg);
		background-position: 8px center;
		background-size: 24px 23px;
		padding-left: 42px;
	}

	.form_input__email {
		background-image: url(/site/images/icon/highlight/input-email.svg);
		background-position: 7px center;
		background-size: 32px 23px;
		padding-left: 46px;
	}

	.input-replacement {
		display: inline-block;
		font-weight: 500;
	}

	.required {
		label {
			&:after {
				content: ' *';
			}
		}

		.label__notrequired {
			&:after {
				content: none;
			}
		}
	}
}
.form_item {
	@extend %clearfix;

	label {
		display: block;
	}

	+ .form_item {
		margin-top: 30px;
	}
}

.form_split {
	display: flex;
	flex-wrap: wrap;
	margin-left: -15px;
	margin-right: -15px;

	.form_item {
		flex: 0 0 50%;
		padding-left: 15px;
		padding-right: 15px;

		+ .form_item {
			margin-top: 0;
		}
	}
}
.form_split_3 {
	.form_item {
		flex-basis: 100%;
		flex-grow: 0;
		max-width: 100%;

		+ .form_item {
			margin-top: 15px;
		}

		@include min(768px) {
			flex-basis: 33.3333%;

			+ .form_item {
				margin-top: 0;
			}
		}
	}
}

.form_buttons {
	text-align: center;
}

.form-errors {
	background: #FEE;
	border: 1px solid #F00;
	color: #F00;
	padding: 10px;

	:last-child {
		margin-bottom: 0;
	}
}


// ----- Alerts ----- //
%alert {
	border-style: solid;
	border-width: 1px;
	padding: 10px;

	* {
		margin: 0;
	}

	* + * {
		margin-top: 10px;
	}

	+ * {
		// margin-top: 1.4rem;
		margin-top: $spacing;
	}
}
.alert-error {
	@extend %alert;
	background-color: #FEE;
	border-color: #F00;
	color: #F00;
}
.alert-warning {
	@extend %alert;
	background-color: #FFE;
	border-color: #C90;
	color: #C90;
}
.alert-success {
	@extend %alert;
	background-color: #EFE;
	border-color: #090;
	color: #090;
}

// ----- Carousel ----- //
.carousel-wrap {
	overflow: hidden;
	position: relative;

	.carousel {
		@extend %list-reset;
		position: relative; }

	.carousel-item { float: left; }
}


// ----- Big Target ----- //
.hover { cursor: pointer; }

// ----- Templates ----- //


// ----- Editor Styles ----- //

.introtext {
	font-size: rem(20);
	line-height: 1.5;
	text-align: center;
}

.small { font-size: rem(9); }
.xsmall { font-size: rem(8); }
.large { font-size: rem($font-size-lg); }
.xlarge { font-size: rem($font-size-xl); }

.colour-highlight {
	color: $colour-highlight
}

.colour-alt {
	color: $colour-alt
}

.bg-highlight-light {
	background-color: $colour-highlight-lt;
}

.weight-black {
	font-weight: 700;
}
.weight-bold {
	font-weight: 600;
}
.weight-medium {
	font-weight: 500;
}
.weight-normal {
	font-weight: 400;
}
.weight-thin {
	font-weight: 300;
}

.wordwrap-break {
	word-wrap: break-word;
}


// ----- Style Overrides ----- //
// Yes it uses !important but these are dedicated specific overrides //
// They are add on a per-element basis and are only ever to be used by the user //
// NEVER ADD THESE TO THE CODED FILES. IF YOU DO YOU ARE A BAD PERSON AND BAD THINGS SHOULD HAPPEN TO YOU //
.bgsz-cover {
	background-size: cover !important;
}
.bgsz-contain {
	background-size: contain !important;
}
.bgsz-normal {
	background-size: auto auto !important;
}


// ----- Forms ----- //

[class^=form-] {

}


// ----- iFrames ----- //

iframe {

}

.iframe-embed {
	position: relative;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
}


// ----- Tables ----- //
table:not(.ui-datepicker-calendar) {
	width: 100%;

	th {
		background-color: $colour-highlight;
		color: #FFF;
		font-size: rem(18);
		font-weight: 700;
		padding: 8px;
		text-align: center;
		text-transform: uppercase;
	}

	td {
		background-color: #e8dcea;
		color: $colour-highlight;
		padding: 9px 18px;
	}

	tr {
		&:nth-child(2n) {
			td {
				background-color: #d1b8d5;
			}
		}
	}
}
.gt-ie9 .tbl-mobile {
	@media only screen and (max-width: 768px){
		&, table, tbody, tr, td { display: block; }
		thead, th { display: none; }
	}
}

.tbl-mobile-attr {
	@media only screen and (max-width: 767px){
		tr {
			border: 1px solid $colour-highlight;
			margin-bottom: 20px;
		}
		td {
			&:before {
				background-color: $colour-highlight;
				color: #FFF;
				content: attr(title);
				display: block;
				font-weight: 700;
			}
		}
	}
}



// ----- Plugin Styling ----- //

/* ShareThis */
.sharethis {
	span {
		box-sizing: content-box;
	}
}

/* Slider */

.slick-slider {
	position: relative;
	display: block;
	box-sizing: border-box;
	-moz-box-sizing: border-box;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	-ms-touch-action: none;
	touch-action: none;
	-webkit-tap-highlight-color: rgba(0,0,0,0);
}
.slick-list {
	position: relative;
	overflow: hidden;
	display: block;
	margin: 0;
	padding: 0;

	&:focus {
		outline: none;
	}

	.slick-loading & {
		background: #fff url(/site/images/ajax-loader.gif) center center no-repeat;
	}

	&.dragging {
		cursor: pointer;
		cursor: hand;
	}
}
.slick-slider .slick-list,
.slick-track,
.slick-slide,
.slick-slide img {
	-webkit-transform: translate3d(0, 0, 0);
	-moz-transform: translate3d(0, 0, 0);
	-ms-transform: translate3d(0, 0, 0);
	-o-transform: translate3d(0, 0, 0);
	transform: translate3d(0, 0, 0);
}
.slick-track {
	position: relative;
	left: 0;
	top: 0;
	display: block;
	zoom: 1;

	&:before,
	&:after {
		content: "";
		display: table;
	}

	&:after {
		clear: both;
	}

	.slick-loading & {
		visibility: hidden;
	}
}
.slick-slide {
	float: left;
	height: 100%;
	min-height: 1px;
	img {
		display: block;
		&.slick-loading {
			background: white url(/site/images/ajax-loader.gif) center center no-repeat;
			padding-bottom: 100%;
		}
	}

	display: none;

	&.dragging img {
		pointer-events: none;
	}

	.slick-initialized & {
		display: block;
	}

	.slick-loading & {
		visibility: hidden;
	}

	.slick-vertical & {
		display: block;
		height: auto;
		border: 1px solid transparent;
	}
}

/* Icons */
 @font-face {
	font-family:"slick";
	src:url("/site/fonts/slick.eot");
	src:url("/site/fonts/slick.eot?#iefix") format("embedded-opentype"), url("/site/fonts/slick.woff") format("woff"), url("/site/fonts/slick.ttf") format("truetype"), url("/site/fonts/slick.svg#slick") format("svg");
	font-weight: normal;
	font-style: normal;
}

/* Arrows */

.slick-prev,
.slick-next {
	position: absolute;
	display: block;
	height: 20px;
	width: 20px;
	line-height: 0;
	font-size: 0;
	cursor: pointer;
	background: transparent;
	color: transparent;
	top: 50%;
	margin-top: -10px;
	padding: 0;
	border: none;
	outline: none;
	&:focus {
		outline: none;
	}
	&.slick-disabled:before {
		opacity: 0.25;
	}
}
.slick-prev:before, .slick-next:before {
	font-family:"slick";
	font-size: 20px;
	line-height: 1;
	color: white;
	opacity: 0.85;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.slick-prev {
	left: -25px;
	&:before {
		content:'\8592';
	}
}
.slick-next {
	right: -25px;
	&:before {
		content:'\8594';
	}
}

/* Dots */

.slick-slider {
	margin-bottom: 30px;
}
.slick-dots {
	position: absolute;
	bottom: -45px;
	list-style: none;
	display: block;
	text-align: center;
	padding: 0px;
	width: 100%;

	li {
		position: relative;
		display: inline-block;
		height: 20px;
		width: 20px;
		margin: 0px 5px;
		padding: 0px;
		cursor: pointer;

		button {
			border: 0;
			background: transparent;
			display: block;
			height: 20px;
			width: 20px;
			outline: none;
			line-height: 0;
			font-size: 0;
			color: transparent;
			padding: 5px;
			cursor: pointer;
			outline: none;
			&:focus {
				outline: none;
			}

			&:before {
				position: absolute;
				top: 0;
				left: 0;
				content:'\8226';
				width: 20px;
				height: 20px;
				font-family:"slick";
				font-size: 6px;
				line-height: 20px;
				text-align: center;
				color: black;
				opacity: 0.25;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;
			}

		}

		&.slick-active button:before {
			opacity: 0.75;
		}
	}
}